export default __webpack_public_path__ + "static/media/targetsImg.b8751f7d.png";